export { campaignPath } from '@brands/shared';

export const formatCount = (n: number, one: string, many: string): string => `${n} ${n === 1 ? one : many}`;
